import * as React from "react";

import { Table } from "semantic-ui-react";

import { getMedicalTypeName } from "@teamprevent/common/customMedicalTypes/model";

import { CustomMedicalType } from "../models";

import { RecallModel } from "./models";

type Props = {
    recalls: RecallModel[];
    customMedicalTypes: CustomMedicalType[] | undefined;
}

const RecallDetails: React.FunctionComponent<Props> = (props) => {
    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>
                        Current Recall Plan
                    </Table.HeaderCell>
                    <Table.HeaderCell />
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {props.recalls.map(recall =>
                    (<Table.Row key={recall.date.toISOString()}>
                        <Table.Cell>
                            <strong>{recall.date.format("Do MMM YYYY")}</strong>
                        </Table.Cell>
                        <Table.Cell>
                            {recall.medicals.map(m => getMedicalTypeName(props.customMedicalTypes, m)).join(", ")}
                        </Table.Cell>
                    </Table.Row>)
                )}
            </Table.Body>
        </Table>
    );
};

export { RecallDetails };
